import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A positioning group inside a canvas item that keeps the item's canvas key. three
 * takes `groupOrder` from the nearest `Group` (`WebGLRenderer.js:1838-1840`), so a
 * bare group resets the key to 0 and its pixels fall behind the background, while a
 * `mesh.renderOrder` test passes. `paintGroupConformance.test.ts` rejects a bare group.
 */
import { createContext, forwardRef, useContext } from 'react';
const CanvasKeyContext = createContext(0);
CanvasKeyContext.displayName = 'CanvasKeyContext';
/**
 * The enclosing canvas item's draw-order key, published where an item's wrapper
 * group is created: `<CanvasItem2D>` for the 2D world, `ControlCanvasWalker` for Controls.
 */
export function useCanvasItemKey() {
    return useContext(CanvasKeyContext);
}
export function CanvasItemKeyProvider({ value, children }) {
    return _jsx(CanvasKeyContext.Provider, { value: value, children: children });
}
/**
 * A `<group>` carrying the canvas key. Pass `renderOrder` only for a group at
 * another canvas position, such as `ScrollContainer`'s bars, which draw after the
 * node's whole subtree (`subtreeChromeRenderOrder`). That key is then the key of
 * every group inside it.
 */
export const CanvasItemGroup = forwardRef(function CanvasItemGroup({ renderOrder, children, ...props }, ref) {
    const inherited = useCanvasItemKey();
    const canvasKey = renderOrder ?? inherited;
    return (_jsx("group", { ref: ref, renderOrder: canvasKey, ...props, children: _jsx(CanvasKeyContext.Provider, { value: canvasKey, children: children }) }));
});
//# sourceMappingURL=CanvasItemGroup.js.map